import { LINKS } from "@/features/dashboard/lib/links";
import { Button, Card, Group, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FiDownload, FiLink } from "react-icons/fi";

export function QuickLinksWidget() {
  const { t } = useTranslation("dashboard");

  return (
    <Card withBorder padding="lg" h="100%">
      <Stack gap="sm">
        <Group gap="xs">
          <FiLink aria-hidden="true" />
          <Title order={4}>{t("widgets.links.title")}</Title>
        </Group>

        <Stack gap="xs">
          {LINKS.map((item) => (
            <Button
              key={item.id}
              component="a"
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              variant="light"
              fullWidth
              justify="flex-start"
              leftSection={<FiDownload aria-hidden="true" />}
            >
              {t(item.labelKey)}
            </Button>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
}
